import React, { useState } from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Form,
    DatePicker,
    Button,
    message,
    Statistic,
    Select,
    Skeleton,
    Result
} from 'antd'
// import {
//     SearchOutlined
// } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import axios from '../../config/axios';
import AddProduct from './components/AddProduct';
import CartItems from './components/CartItems';

const paymentTypes = [
    { value: 0, label: 'เงินสด' },
    { value: 30, label: 'เครดิต 30 วัน' },
    { value: 45, label: 'เครดิต 45 วัน' },
    { value: 45, label: 'เครดิต 60 วัน' },
]
function Create() {
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [shipments, setShipments] = useState([]);
    const [billingDate, setBillingDate] = useState(dayjs());
    const newOrderQuery = useQuery({ queryKey: ['/api/transaction/getLastOrder'] });
    const customerQuery = useQuery({ queryKey: ['/api/customer/'] });
    const employeeQuery = useQuery({ queryKey: ['/api/employee/'] });
    const productQuery = useQuery({ queryKey: ['/api/product/getActiveProducts'] });
    const cartItemQuery = useQuery({ queryKey: ['/api/cartItem/getOrderCartItems'] });
    const queryClient = useQueryClient();
    const redirect = useNavigate();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/transaction/createTransaction', data)
                .then(res => {
                    // console.log("create customer :",res);
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => {
                            queryClient.invalidateQueries(['/api/transaction/getLastOrder']);
                            redirect(`/admin/orders/${res.data._id}`);
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    if (customerQuery.isLoading || employeeQuery.isLoading || productQuery.isLoading || cartItemQuery.isLoading || newOrderQuery.isLoading) {
        return <Skeleton active />
    }

    if (customerQuery.isError || employeeQuery.isError || productQuery.isError || cartItemQuery.isError || newOrderQuery.isError) {
        return <Result
            status="error"
            title={
                customerQuery.error.message
                || employeeQuery.error.message
                || productQuery.error.message
                || cartItemQuery.error.message
                || newOrderQuery.error.message
            }
        />
    };

    const onSelectCustomer = (info) => {
        const tagetCustomer = customerQuery.data.find(f => f._id === info);
        setShipments(tagetCustomer.shipments);
    }

    const onSelectPaymenetType = (value, option) => {
        // console.log('value; ', value);
        setBillingDate(form.getFieldValue('shipment_date').add(value, 'day'));
    }

    const onSelectVatFlag = (info) => {

        // console.log(e);
        // const discount = form.getFieldValue("discount");
        let grand_total = cartItemQuery.data.reduce((prev, cur) => prev + cur.total_price, 0);
        let total = grand_total;
        let vat = 0;

        if (info === 'ราคารวมภาษี') {
            total = grand_total / 1.07;
            vat = grand_total - total;
        }


        form.setFieldsValue({
            ...form.getFieldsValue(true),
            total,
            // discount,
            vat,
            grand_total
        });

    }
    // const onDiscountChange = (value) => {

    //     const discount = value;
    //     let total = cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.price), 0);
    //     let vat = 0;

    //     if (form.getFieldValue("vatFlag") === 'ราคารวมภาษี') {
    //         total = cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * (cur.price / 1.07)), 0);
    //         vat = (total - discount) * 0.07;
    //     }

    //     const grand_total = total - discount + vat;

    //     form.setFieldsValue({
    //         ...form.getFieldsValue(true),
    //         total,
    //         discount,
    //         vat,
    //         grand_total
    //     });
    // }
    const onFinish = (values) => {
        form
            .validateFields()
            // .then(values => mutate(values))
            .then(values => {
                const discount = form.getFieldValue("discount");
                let total = cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.selling_price), 0);
                let vat = 0;

                if (values.vatFlag === 'ราคารวมภาษี') {
                    total = cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * (cur.selling_price / 1.07)), 0);
                    vat = (total - discount) * 0.07;
                }

                const grand_total = total - discount + vat;

                mutate({
                    ...values,
                    transaction_type: 'OUT',
                    billing_date: billingDate,
                    payment_type: values.payment_type.toString(),
                    transactionItems: cartItemQuery.data.map(item => ({
                        product: item.product.id,
                        quantity: item.quantity,
                        price: item.price,
                        discount: item.discount,
                        total_price: item.total_price,
                        selling_price: item.selling_price,
                    })),
                    total,
                    discount,
                    vat,
                    grand_total
                });
            })
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                });
            })
    }


    // console.log("newOrderQuery", newOrderQuery.data)
    // console.log("customerQuery", customerQuery.data)
    // console.log("employeeQuery", employeeQuery.data)
    // console.log("productQuery", productQuery.data)
    // console.log("cartItemsQuery", cartItemQuery.data)
    // console.log("shipments", shipments)
    // console.log("billingDate", billingDate.format('DD/MM/YYYY'))
    // console.log(cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.price), 0))
    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row>
                <Col xs={24} md={16} >
                    <Typography.Title level={3}>
                        สร้างใบแจ้งหนี้
                    </Typography.Title>
                </Col>
                <Divider />
                <Col xs={24}>
                    <Form
                        name="createOrder"
                        layout="vertical"
                        form={form}
                        // onFinish={onFinish}
                        initialValues={{
                            doc_no: newOrderQuery.data,
                            order_date: dayjs(),
                            shipment_date: dayjs(),
                            payment_type: 0,
                            vatFlag: 'ราคาไม่รวมภาษี',
                            total: cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.selling_price), 0),
                            discount: 0,
                            vat: 0,
                            grand_total: cartItemQuery.data.reduce((prev, cur) => prev + (cur.quantity * cur.selling_price), 0),
                        }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="เลขที่เอกสาร"
                                            name="doc_no"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input disabled style={{ background: "#FFF", color: "#000" }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="วันที่สั่งซื้อ"
                                            name="order_date"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="วันที่ส่งของ"
                                            name="shipment_date"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ชื่อลูกค้า"
                                            name="customer"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                onSelect={onSelectCustomer}
                                            >
                                                {customerQuery.data.map((customer) => (
                                                    <Select.Option key={customer._id} value={customer._id} >
                                                        {customer.fname}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ผู้ขาย"
                                            name="employee"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                            >
                                                {employeeQuery.data.map((emp) => (
                                                    <Select.Option key={emp._id} value={emp._id} >
                                                        {emp.fname}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="สถานที่จัดส่ง"
                                            name="shipment"
                                            // rules={[
                                            //     {
                                            //         required: true,
                                            //         message: 'กรุณากรอกข้อมูล!',
                                            //     },
                                            // ]}
                                        >
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                            >
                                                {shipments.map((ship) => (
                                                    <Select.Option key={ship.id} value={ship.id} >
                                                        {`ที่ ${ship.address} แขวง/ตำบล ${ship.sub_district} เขต/อำเภอ ${ship.district} จังหวัด ${ship.province}`}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item name="description" label="รายละเอียด">
                                            <Input.TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>

            </Row>
            <Row justify="start" gutter={[0, 16]} style={{ marginBottom: '16px' }}>
                <Col xs={24} md={16}>
                    <AddProduct
                        products={productQuery.data}
                        cartItems={cartItemQuery.data}
                        formOrder={form}
                    />
                </Col>
                <Col xs={24} md={16}>
                    <CartItems
                        // products={cartItemQuery.data}
                        orderItems={cartItemQuery.data}
                        formOrder={form}
                    />
                </Col>
            </Row>
            <Row >
                <Col xs={24} md={16}>
                    <Row justify="space-between">
                        <Col xs={24} md={12}>
                            <Form
                                name="paymentDetail"
                                layout="vertical"
                                form={form}
                            >
                                <Row gutter={[8, 8]}>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="ประเภทการชำระสินค้า"
                                            name="payment_type"
                                        >
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                onChange={onSelectPaymenetType}
                                            >
                                                {paymentTypes.map((payment) => (
                                                    <Select.Option key={payment.label} value={payment.value} >
                                                        {payment.label}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="ประเภทราคาสินค้า"
                                            name="vatFlag"
                                        >
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                onChange={onSelectVatFlag}
                                            >
                                                {[{ key: '1', value: 'ราคาไม่รวมภาษี' }, { key: '2', value: 'ราคารวมภาษี' }].map((vat) => (
                                                    <Select.Option key={vat.key} value={vat.value} >
                                                        {vat.value}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    {/* <Col xs={24}>
                                        <Form.Item
                                            label="ส่วนลด"
                                            name="discount"
                                        >
                                            <InputNumber onChange={onDiscountChange} style={{ width: "100%" }} />
                                        </Form.Item>
                                    </Col> */}
                                </Row>
                            </Form>
                        </Col>
                        <Col xs={24} md={12}>
                            <Row justify="end">
                                <Col xs={12}>
                                    <Form form={form}>
                                        <Row justify="end">
                                            <Col xs={12}>
                                                <Typography>ราคารวม :</Typography>
                                            </Col>
                                            <Col xs={12} >
                                                <Form.Item shouldUpdate>
                                                    {() => {

                                                        return <Statistic
                                                            value={form.getFieldValue('total')}
                                                            precision={2}
                                                            valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                        />
                                                    }}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        {/* <Row justify="end">
                                            <Col xs={12}>
                                                <Typography>ส่วนลด :</Typography>
                                            </Col>
                                            <Col xs={12} >
                                                <Form.Item shouldUpdate>
                                                    {() => {

                                                        return <Statistic
                                                            value={form.getFieldValue('discount')}
                                                            precision={2}
                                                            valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                        />
                                                    }}
                                                </Form.Item>
                                            </Col>
                                        </Row> */}
                                        <Row justify="end">
                                            <Col xs={12}>
                                                <Typography>ภาษีมูลค่าเพิ่ม 7% :</Typography>
                                            </Col>
                                            <Col xs={12} >
                                                <Form.Item shouldUpdate>
                                                    {() => {

                                                        return <Statistic
                                                            value={form.getFieldValue('vat')}
                                                            precision={2}
                                                            valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                        />
                                                    }}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                        <Row justify="end">
                                            <Col xs={12}>
                                                <Typography>ราคาสุทธิ:</Typography>
                                            </Col>
                                            <Col xs={12} >
                                                <Form.Item shouldUpdate>
                                                    {() => {

                                                        return <Statistic
                                                            value={form.getFieldValue('grand_total')}
                                                            precision={2}
                                                            valueStyle={{ fontSize: '14px', textAlign: 'end' }}
                                                        />
                                                    }}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col xs={24} md={16}>
                    <Row justify='end' >
                        <Col xs={4}>
                            <Button type="primary" disabled={isLoading} onClick={onFinish} style={{ width: "100%" }}>
                                บันทึก
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

        </div>
    )
}

export default Create